<template lang="pug">
  FullView(
    v-if='genre'
    type='genre'
    :id='genre.id'
    :cover='genre.cover'
    :label='$l10n("GENRE").toLowerCase()'
    :title='genre.name || $l10n("NO_NAME")'
    :show-controls='false'
  )
</template>

<script>
import FullView from "@/components/FullView/FullView";

export default {
  inheritAttrs: false,
  name: "GenreFullView",
  props: ["genre"],
  components: {
    FullView
  }
};
</script>
